import { Component,HostListener,Inject, } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { CustomLoaderComponent } from './custom-loader/custom-loader.component';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  // title = 'franksport';
  filteredUrlPatterns:Array<string>=[
    'match/homeMatches','fancy/getFancies','fancy/getFancyLiveData',
    'match/matchDetails','getLiveScore','match/matchDetails',
    'bet/saveBet','event/getEventsLimit','bet/saveFancyBet','match/matchDetailsRunners',
    'user/getBalanceCRef'
  ]
  public custome_loader = CustomLoaderComponent;
  logo: string;
  public constructor(@Inject(DOCUMENT) private document: Document,private titleService: Title) { }

  // @HostListener('window:scroll', [])
  // onWindowScroll() {
  //   if (document.body.scrollTop > 120 ||
  //     document.documentElement.scrollTop > 120) {
  //     document.getElementById('sidebar-right').classList.add('sidebarfixed');
  //   }
  //   else {
  //     document.getElementById('sidebar-right').classList.remove('sidebarfixed');
  //   }
  // }
  // scrollToTop(): void {
  //   // scroll to the top of the body
  //   return this.document.body.scrollIntoView({
  //     behavior: 'smooth',
  //     block: 'start',
  //     inline: 'start'
  //   });
  // }
  // title = 'franks-port-admin';
  ngOnInit(): void {
    this.logo =window.location.hostname;
    let domain_name = this.getDomainName(this.logo)
    let b = (domain_name).split('.')
    this.setTitle(b[0])
  }
  public setTitle(newTitle: string) {
    this.titleService.setTitle('Myexch247 Bet Online India | #1 Cricket & Sports Betting website – Sign Up Now for a 150% Bonus!');
  }
  getDomainName(hostName) {
    return hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1);
  }
}
